<ion-header [translucent]="!modalCtrl">
  <ion-toolbar>
    <ion-title>{{'pages.info.btn-privacy' | translate}}</ion-title>
    @if (modalCtrl) {
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

@if (language === 'de') {
  <ion-content class="ion-padding">
    @if (!modalCtrl) {
      <h1>Datenschutzerklärung</h1>
    }
    <h2>1. Verantwortlicher</h2>
    <p>
      Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
    </p>
    <p>
      EFTAS Fernerkundung Technologietransfer GmbH<br>
      Oststraße 2<br>
      48145 Münster<br>
      Deutschland
    </p>
    <p>
      Telefon: +49 (0)251 1330 70<br>
      E-Mail: info@eftas.com
    </p>
  
    <h2>2. Allgemeine Hinweise</h2>
    <p>
      Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung
      und Nutzung des EFTAS CropAnalyzer, zur Bearbeitung von Anfragen, zur
      technischen Sicherheit oder aufgrund gesetzlicher Pflichten erforderlich ist.
    </p>
    <p>
      Der CropAnalyzer umfasst die Website, mobile Apps, Schnittstellen,
      Integrationslösungen, Tools und sonstige zugehörige Dienste.
    </p>
  
    <h2>3. Nutzung des CropAnalyzer</h2>
    <p>
      Die Nutzung des CropAnalyzer ist grundsätzlich ohne Angabe unmittelbar
      identifizierender personenbezogener Daten möglich. Klassifikationsaufträge
      werden einer technischen Nutzer-ID bzw. einem pseudonymisierten Benutzerkonto
      zugeordnet, damit Ergebnisse bereitgestellt und vor dem Zugriff anderer
      Nutzer geschützt werden können.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung für
      die Bereitstellung der gewünschten Funktionen erforderlich ist. Im Übrigen
      erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser
      berechtigtes Interesse liegt in der sicheren und funktionsfähigen
      Bereitstellung des Dienstes.
    </p>
  
    <h2>4. E-Mail-Adresse und Benachrichtigungsdienst</h2>
    <p>
      Sie können optional eine E-Mail-Adresse angeben, um Benachrichtigungen zur
      Verarbeitung mehrerer Fotos zu erhalten oder um ein Benutzerkonto
      wiederherzustellen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur
      Bereitstellung der gewünschten Funktion erforderlich ist. Erfolgt die Angabe
      freiwillig für zusätzliche Benachrichtigungen, ist Rechtsgrundlage Art. 6
      Abs. 1 lit. a DSGVO. Eine erteilte Einwilligung kann jederzeit mit Wirkung
      für die Zukunft widerrufen werden.
    </p>
  
    <h2>5. Verarbeitung von Fotos und Bildinformationen</h2>
    <p>
      Nutzer können Fotos an den CropAnalyzer übermitteln. Die Fotos werden
      verarbeitet, um Klassifikations- und Analyseergebnisse bereitzustellen.
      Hierbei können auch mit dem Bild verbundene Informationen verarbeitet
      werden, insbesondere Aufnahmezeitpunkt, Aufnahmekoordinaten, technische
      Aufnahmeparameter und Informationen zum verwendeten Endgerät, soweit diese
      in den Bildmetadaten enthalten sind.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur
      Bereitstellung der Analysefunktion erforderlich ist. Soweit eine darüber
      hinausgehende Nutzung erfolgt, geschieht dies nur auf Grundlage einer
      gesonderten Einwilligung oder einer gesonderten vertraglichen Regelung.
    </p>
    <p>
      Bitte laden Sie keine Fotos hoch, auf denen Personen, Kfz-Kennzeichen,
      Schilder mit personenbezogenen Angaben oder sonstige identifizierende
      Merkmale erkennbar sind. Sollten solche Inhalte dennoch übermittelt werden,
      können sie gelöscht oder anonymisiert werden.
    </p>
  
    <h2>6. Standortdaten</h2>
    <p>
      Bei Nutzung standortbezogener Funktionen kann die App auf den Standort Ihres
      Geräts zugreifen, sofern Sie die entsprechende Berechtigung erteilen. Die
      Standortdaten werden insbesondere verwendet, um Fotos zu verorten und
      Karten- oder Analysefunktionen bereitzustellen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO, soweit der Zugriff auf den
      Gerätestandort auf Ihrer Einwilligung beruht. Soweit Standortdaten zur
      Bereitstellung einer von Ihnen angeforderten Funktion erforderlich sind, ist
      zusätzlich Art. 6 Abs. 1 lit. b DSGVO einschlägig.
    </p>
    <p>
      Sie können Standortberechtigungen jederzeit über die Einstellungen Ihres
      Endgeräts widerrufen oder deaktivieren.
    </p>
  
    <h2>7. Geräteberechtigungen der mobilen App</h2>
    <p>
      Zur Bereitstellung der App-Funktionen können folgende Berechtigungen
      erforderlich sein:
    </p>
    <ul>
      <li>
        Standort: zur Verortung von aufgenommenen oder hochgeladenen Fotos.
      </li>
      <li>
        Kamera: zur Aufnahme und Übermittlung neuer Bilder.
      </li>
      <li>
        Fotos, Medien und Dateien: zum Hochladen, Speichern oder Herunterladen von
        Bildern und Ergebnissen.
      </li>
      <li>
        Internetzugriff: zur Kommunikation mit den Servern des CropAnalyzer.
      </li>
    </ul>
  
    <h2>8. Kontakt- und Feedbackformular</h2>
    <p>
      Wenn Sie uns per Kontakt- oder Feedbackformular kontaktieren, verarbeiten
      wir Ihre Angaben zur Bearbeitung der Anfrage und für mögliche
      Anschlussfragen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit
      einem Vertrag oder vorvertraglichen Maßnahmen zusammenhängt. In allen
      übrigen Fällen ist Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Unser
      berechtigtes Interesse liegt in der Bearbeitung Ihrer Anfrage.
    </p>
  
    <h2>9. Server-Logfiles</h2>
    <p>
      Beim Aufruf unserer Website oder Dienste werden technisch erforderliche
      Zugriffsdaten verarbeitet. Dazu können insbesondere gehören:
    </p>
    <ul>
      <li>IP-Adresse</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
      <li>aufgerufene Seite oder Datei</li>
      <li>übertragene Datenmenge</li>
      <li>Zugriffsstatus</li>
      <li>verwendeter Browser und Betriebssystem</li>
      <li>Referrer-URL</li>
    </ul>
    <p>
      Die Verarbeitung erfolgt zur technischen Bereitstellung, zur Fehleranalyse
      und zur Systemsicherheit. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
    </p>
  
    <h2>10. Matomo</h2>
    <p>
      Wir nutzen Matomo, eine Open-Source-Software zur statistischen Auswertung
      der Nutzung unseres Angebots.
    </p>
    <p>
      Matomo wird nur eingesetzt, wenn Sie über unsere Consent-Abfrage in die
      Verarbeitung eingewilligt haben. Matomo verwendet Cookies, die eine Analyse
      der Nutzung unserer Website und Dienste ermöglichen.
    </p>
    <p>
      Verarbeitet werden können insbesondere:
    </p>
    <ul>
      <li>aufgerufene Seiten</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
      <li>Verweildauer</li>
      <li>verwendeter Browser</li>
      <li>verwendetes Betriebssystem</li>
      <li>anonymisierte IP-Adresse</li>
      <li>Referrer-URL</li>
    </ul>
    <p>
      Die IP-Adresse wird gekürzt bzw. anonymisiert verarbeitet, bevor sie
      gespeichert wird. Eine unmittelbare Zuordnung zu einzelnen Personen ist
      dadurch nicht möglich.
    </p>
    <p>
      Rechtsgrundlage ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO
      sowie § 25 Abs. 1 TDDDG. Sie können Ihre Einwilligung jederzeit mit Wirkung
      für die Zukunft über die Consent-Einstellungen widerrufen oder anpassen.
    </p>
  
    <h2>11. Cookies und vergleichbare Technologien</h2>
    <p>
      Wir verwenden technisch erforderliche Cookies und vergleichbare Technologien,
      soweit diese für den Betrieb unserer Dienste erforderlich sind.
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO sowie § 25 Abs. 2 TDDDG.
    </p>
    <p>
      Analyse-Cookies, insbesondere für Matomo, setzen wir nur nach Ihrer
      vorherigen Einwilligung ein. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO
      sowie § 25 Abs. 1 TDDDG.
    </p>
  
    <h2>12. Empfänger und Auftragsverarbeiter</h2>
    <p>
      Personenbezogene Daten werden nur an Dritte übermittelt, wenn dies zur
      Bereitstellung des CropAnalyzer erforderlich ist, eine gesetzliche Pflicht
      besteht oder Sie eingewilligt haben.
    </p>
    <p>
      Soweit wir Dienstleister einsetzen, die personenbezogene Daten in unserem
      Auftrag verarbeiten, erfolgt dies auf Grundlage eines Vertrags zur
      Auftragsverarbeitung gemäß Art. 28 DSGVO.
    </p>
  
    <h2>13. Speicherdauer</h2>
    <p>
      Wir speichern personenbezogene Daten nur so lange, wie dies für die
      jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
      bestehen. Nach Wegfall des Zwecks oder Ablauf gesetzlicher Fristen werden
      die Daten gelöscht oder anonymisiert.
    </p>
    <p>
      Hochgeladene Fotos, Analyseergebnisse, technische Nutzer-IDs und optionale
      E-Mail-Adressen werden gelöscht, sobald sie für die Bereitstellung des
      Dienstes nicht mehr erforderlich sind oder Sie eine Löschung verlangen,
      sofern keine gesetzlichen oder vertraglichen Gründe entgegenstehen.
    </p>
  
    <h2>14. Ihre Rechte</h2>
    <p>
      Sie haben nach Maßgabe der gesetzlichen Vorschriften folgende Rechte:
    </p>
    <ul>
      <li>Recht auf Auskunft gemäß Art. 15 DSGVO</li>
      <li>Recht auf Berichtigung gemäß Art. 16 DSGVO</li>
      <li>Recht auf Löschung gemäß Art. 17 DSGVO</li>
      <li>Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
      <li>Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
      <li>Recht auf Widerspruch gemäß Art. 21 DSGVO</li>
      <li>Recht auf Widerruf erteilter Einwilligungen gemäß Art. 7 Abs. 3 DSGVO</li>
    </ul>
  
    <h2>15. Beschwerderecht bei einer Aufsichtsbehörde</h2>
    <p>
      Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
      beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
      personenbezogenen Daten gegen Datenschutzrecht verstößt.
    </p>
  
    <h2>16. Datensicherheit</h2>
    <p>
      Wir treffen technische und organisatorische Maßnahmen, um personenbezogene
      Daten gegen Verlust, Missbrauch, unbefugten Zugriff oder unbefugte
      Offenlegung zu schützen. Dennoch kann eine Datenübertragung im Internet
      Sicherheitsrisiken aufweisen.
    </p>
  
    <h2>17. Änderung dieser Datenschutzerklärung</h2>
    <p>
      Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich die
      rechtlichen, technischen oder organisatorischen Rahmenbedingungen ändern.
      Es gilt jeweils die aktuelle veröffentlichte Fassung.
    </p>
  </ion-content>
  
} @else {
  <ion-content class="ion-padding">
    @if (!modalCtrl) {
      <h1>Privacy Policy</h1>
    }
    <h2>1. Controller</h2>
    <p>
      The controller within the meaning of the General Data Protection Regulation
      (GDPR) is:
    </p>
    <p>
      EFTAS Fernerkundung Technologietransfer GmbH<br>
      Oststraße 2<br>
      48145 Münster<br>
      Germany
    </p>
    <p>
      Phone: +49 (0)251 1330 70<br>
      Email: info@eftas.com
    </p>
  
    <h2>2. General Information</h2>
    <p>
      We process personal data only to the extent necessary to provide and operate
      the EFTAS CropAnalyzer service, to respond to inquiries, to ensure technical
      security, or to comply with legal obligations.
    </p>
    <p>
      CropAnalyzer includes the website, mobile applications, APIs, integration
      solutions, tools, and related services.
    </p>
  
    <h2>3. Use of CropAnalyzer</h2>
    <p>
      CropAnalyzer can generally be used without providing directly identifiable
      personal data. Classification requests are assigned to a technical user ID
      or pseudonymous user account in order to provide results and protect user
      data from unauthorized access.
    </p>
    <p>
      The legal basis for this processing is Article 6(1)(b) GDPR where the
      processing is necessary to provide the requested service. In other cases,
      processing is based on Article 6(1)(f) GDPR. Our legitimate interest lies
      in the secure and reliable operation of the service.
    </p>
  
    <h2>4. Email Address and Notification Service</h2>
    <p>
      You may optionally provide an email address in order to receive
      notifications regarding the processing of multiple photos or to recover a
      user account.
    </p>
    <p>
      The legal basis is Article 6(1)(b) GDPR where the processing is necessary
      to provide the requested functionality. Where the email address is provided
      voluntarily for additional notifications, the legal basis is Article
      6(1)(a) GDPR. Consent may be withdrawn at any time with future effect.
    </p>
  
    <h2>5. Processing of Photos and Image Information</h2>
    <p>
      Users may upload photos to CropAnalyzer. The photos are processed solely for
      the purpose of performing the requested analysis and classification and for
      providing the corresponding results.
    </p>
  
    <p>
      Information associated with the uploaded images may also be processed,
      including the date and time of capture, geographic coordinates, technical
      camera parameters, and device information contained in image metadata
      (EXIF data), where required for processing.
    </p>
  
    <p>
      The legal basis for this processing is Article 6(1)(b) GDPR.
    </p>
  
    <p>
      Uploaded photos and their associated metadata are not used for marketing
      purposes, profiling, publication, AI model training, or any purpose other
      than providing the CropAnalyzer service.
    </p>
  
    <p>
      Please do not upload photos containing identifiable persons, vehicle
      registration plates, or other personally identifiable information.
    </p>
  
    <h2>6. Location Data</h2>
    <p>
      When using location-based functions, the app may access your device's
      location if you grant the corresponding permission. Location data is used
      primarily to georeference photos and to provide mapping and analysis
      functions.
    </p>
    <p>
      The legal basis is Article 6(1)(a) GDPR where access to device location is
      based on your consent. Where location data is required to provide a
      function explicitly requested by you, Article 6(1)(b) GDPR also applies.
    </p>
    <p>
      You may revoke location permissions at any time through your device
      settings.
    </p>
  
    <h2>7. Mobile App Permissions</h2>
    <p>
      The following permissions may be required to provide app functionality:
    </p>
    <ul>
      <li>
        Location: for georeferencing captured or uploaded photos.
      </li>
      <li>
        Camera: for capturing and submitting new photos.
      </li>
      <li>
        Photos, Media and Files: for uploading, storing, and downloading photos
        and analysis results.
      </li>
      <li>
        Internet Access: for communication with CropAnalyzer servers.
      </li>
    </ul>
  
    <h2>8. Contact and Feedback Forms</h2>
    <p>
      If you contact us via a contact or feedback form, we process the
      information you provide in order to handle your request and any follow-up
      inquiries.
    </p>
    <p>
      The legal basis is Article 6(1)(b) GDPR where your request relates to a
      contract or pre-contractual measures. In all other cases, the legal basis
      is Article 6(1)(f) GDPR. Our legitimate interest is the efficient handling
      of inquiries.
    </p>
  
    <h2>9. Server Log Files</h2>
    <p>
      When accessing our website or services, technically necessary access data
      may be processed, including:
    </p>
    <ul>
      <li>IP address</li>
      <li>Date and time of access</li>
      <li>Requested page or file</li>
      <li>Amount of data transferred</li>
      <li>Access status</li>
      <li>Browser and operating system information</li>
      <li>Referrer URL</li>
    </ul>
    <p>
      Processing is carried out to ensure technical operation, system security,
      and error analysis. The legal basis is Article 6(1)(f) GDPR.
    </p>
  
    <h2>10. Matomo Analytics</h2>
    <p>
      We use Matomo, an open-source analytics platform, to evaluate the use of
      our services.
    </p>
    <p>
      Matomo is only activated if you have provided consent through our consent
      management mechanism. Matomo uses cookies that enable analysis of website
      and service usage.
    </p>
    <p>
      The following data may be processed:
    </p>
    <ul>
      <li>Visited pages</li>
      <li>Date and time of access</li>
      <li>Session duration</li>
      <li>Browser information</li>
      <li>Operating system information</li>
      <li>Anonymized IP address</li>
      <li>Referrer URL</li>
    </ul>
    <p>
      IP addresses are truncated or anonymized before storage. Direct
      identification of individual users is therefore not possible.
    </p>
    <p>
      The legal basis is your consent pursuant to Article 6(1)(a) GDPR and
      Section 25(1) German Telecommunications Digital Services Data Protection
      Act (TDDDG). You may withdraw or modify your consent at any time with
      future effect through the consent settings.
    </p>
  
    <h2>11. Cookies and Similar Technologies</h2>
    <p>
      We use technically necessary cookies and similar technologies where
      required for the operation of our services. The legal basis is Article
      6(1)(f) GDPR and Section 25(2) TDDDG.
    </p>
    <p>
      Analytics cookies, particularly those used by Matomo, are only deployed
      after obtaining your prior consent. The legal basis is Article 6(1)(a)
      GDPR and Section 25(1) TDDDG.
    </p>
  
    <h2>12. Recipients and Processors</h2>
    <p>
      Personal data is only disclosed to third parties where necessary for the
      provision of CropAnalyzer, where required by law, or where you have given
      your consent.
    </p>
    <p>
      Where service providers process personal data on our behalf, such
      processing is carried out under a data processing agreement pursuant to
      Article 28 GDPR.
    </p>
  
    <h2>13. Retention Period</h2>
    <p>
      Personal data is stored only for as long as necessary for the purposes
      described above or as required by statutory retention obligations. Data is
      deleted or anonymized once the purpose no longer applies.
    </p>
    <p>
      Uploaded photos, analysis results, technical user IDs, and optional email
      addresses are deleted once they are no longer required for the provision of
      the service or upon request for deletion, unless legal or contractual
      obligations require longer retention.
    </p>
  
    <h2>14. Your Rights</h2>
    <p>
      Under applicable data protection law, you have the following rights:
    </p>
    <ul>
      <li>Right of access (Article 15 GDPR)</li>
      <li>Right to rectification (Article 16 GDPR)</li>
      <li>Right to erasure (Article 17 GDPR)</li>
      <li>Right to restriction of processing (Article 18 GDPR)</li>
      <li>Right to data portability (Article 20 GDPR)</li>
      <li>Right to object (Article 21 GDPR)</li>
      <li>Right to withdraw consent (Article 7(3) GDPR)</li>
    </ul>
  
    <h2>15. Right to Lodge a Complaint</h2>
    <p>
      You have the right to lodge a complaint with a supervisory authority if you
      believe that the processing of your personal data violates applicable data
      protection law.
    </p>
  
    <h2>16. Data Security</h2>
    <p>
      We implement appropriate technical and organizational measures to protect
      personal data against loss, misuse, unauthorized access, or disclosure.
      However, data transmission over the Internet can never be completely secure.
    </p>
  
    <h2>17. Changes to this Privacy Policy</h2>
    <p>
      We reserve the right to amend this Privacy Policy where required due to
      legal, technical, or organizational changes. The version published on this
      website shall apply.
    </p>
  </ion-content>  
} @if (modalCtrl) {
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()" color="secondary"
        >{{'shared.btn-close' | translate}}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
}
